/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_3Inputs */

const en_pc_tut_open_3 = /** @type {(inputs: Pc_Tut_Open_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom with the controls on the right edge, or pinch on a trackpad.`)
};

const zh_pc_tut_open_3 = /** @type {(inputs: Pc_Tut_Open_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用右侧边栏的按钮缩放，或在触控板上双指捏合。`)
};

/**
* | output |
* | --- |
* | "Zoom with the controls on the right edge, or pinch on a trackpad." |
*
* @param {Pc_Tut_Open_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_3 = /** @type {((inputs?: Pc_Tut_Open_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_3(inputs)
	return zh_pc_tut_open_3(inputs)
});
export { pc_tut_open_3 as "pc.tut.open.3" }